<template>
  <div class="qrcode-page">
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QRCodePage',
  data() {
    return {
      qrText: '', // 将根据URL参数动态设置
      qrCodeDataURL: '',
      redirectUrl: ''
    }
  },
  mounted(id) {
    // 组件挂载后获取URL参数并处理重定向
    this.handleUrlParams()
  },
  methods: {
    handleUrlParams() {
      // 获取URL参数中的id
      
      const id = this.$route.query.id;
      console.log(id)
      if (id) {
        // 如果有id参数，构建重定向URL并跳转
        const redirectUrl = `http://scxc.zgktt.com:8001/webApp/toQrcodeDetail?id=${id}`
        this.redirectUrl = redirectUrl
        this.qrText = redirectUrl
        
        // 生成二维码
        this.generateQRCode()
        
        // 延迟2秒后重定向，给用户查看二维码的时间
          window.location.href = redirectUrl
        
      } else {
        // 如果没有id参数，显示默认内容
        this.qrText = 'Hello Vue2 QRCode!'
        this.generateQRCode()
      }
    },
    
    async generateQRCode() {
      if (!this.qrText.trim()) {
        this.qrCodeDataURL = ''
        return
      }
      
      try {
        // 生成二维码
        const url = await QRCode.toDataURL(this.qrText, {
          width: 300,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
        this.qrCodeDataURL = url
      } catch (error) {
        console.error('生成二维码失败:', error)
        this.qrCodeDataURL = ''
      }
    }
  }
}
</script>

<style scoped>
.qrcode-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.container {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 100%;
}

.title {
  color: #333;
  margin-bottom: 30px;
  font-size: 2.2em;
  font-weight: 600;
}

.input-section {
  margin-bottom: 30px;
}

.text-input {
  width: 100%;
  padding: 15px;
  border: 2px solid #e1e5e9;
  border-radius: 10px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.text-input:focus {
  border-color: #667eea;
}

.qrcode-section {
  margin-bottom: 30px;
}

.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 15px;
}

.qrcode-image {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
}

.placeholder {
  padding: 60px 20px;
  background: #f8f9fa;
  border-radius: 15px;
  color: #6c757d;
  font-style: italic;
}

.info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 10px;
  text-align: left;
}

.current-text {
  margin: 0;
  color: #495057;
  font-size: 14px;
  word-break: break-all;
}

/* 响应式设计 */
@media (max-width: 600px) {
  .container {
    padding: 20px;
    margin: 10px;
  }
  
  .title {
    font-size: 1.8em;
  }
}
</style> 